import React from 'react';
import { TaskForm } from '../../components/Tasks';

const TaskCreate = () => {
  return <TaskForm />;
};

export default TaskCreate;


